export const mockProfile = {
  name: 'The Oxford System, Lahore Campus',
  role: 'Administrator',
  email: 'admin@schoolmentor.app',
  phone: '+92 300 0000000',
  campus: 'The Oxford System, Lahore Campus',
  memberSince: 'May 2024',
  lastLogin: 'Today, 1:02 PM',
};
